<template lang="html">
  <div class="start-xs student-submission-text readable-text">
    <div
      :ref="submission_text_ref"
      :id="submission_text_ref"
      v-html="highlightedPromptResponse"
      class="response-text"
      :class="[
        { 'pl-caption': smallFont },
        { fadeout: show_fadeout_on_text },
        { 'fadeout-shortened': show_fadeout_on_text && shortenText },
      ]"
    ></div>
    <a
      v-if="show_minimize_button && !disableMinimizeText"
      class="pl-caption italics"
      style="cursor: pointer"
      @click.stop.prevent="toggleMinimizeResponse"
    >
      {{ minimize_response_text ? 'Expand' : 'Minimize' }}
    </a>
  </div>
</template>
<script>
  export default {
    data() {
      return {
        submission_content_height: null,
        minimize_response_text: true,
        show_minimize_button: false,
        viewInContextSentence: null,
      };
    },
    props: {
      submission: {
        type: Object,
        default() {
          return {
            id: null,
          };
        },
      },
      shortenText: {
        type: Boolean,
        default: false,
      },
      smallFont: {
        type: Boolean,
        default: false,
      },
      disableMinimizeText: {
        type: Boolean,
        default: false,
      },
    },
    computed: {
      highlightedPromptResponse() {
        if (this.viewInContextSentence) {
          let temporalDivElement = document.createElement('div');
          temporalDivElement.innerHTML = this.submission.prompt_response;

          let innerTxt =
            temporalDivElement.textContent ||
            temporalDivElement.innerText ||
            '';
          innerTxt = innerTxt
            .replaceAll(/\n/g, '<br><br>')
            .replaceAll(
              this.viewInContextSentence,
              '<span style="background: #CBC3FA">' +
                this.viewInContextSentence +
                '</span> '
            );
          innerTxt = innerTxt
            .replace(/\n/, '<br><br>')
            .replaceAll(
              '<span style="background: #CBC3FA">' +
                this.viewInContextSentence +
                '</span> ',
              '<span id="scrollHere" style="background: #CBC3FA">' +
                this.viewInContextSentence +
                '</span> '
            );

          return innerTxt;
        }
        return this.response_adjusted_with_links;
      },
      show_fadeout_on_text() {
        return (
          !this.disableMinimizeText &&
          this.minimize_response_text &&
          this.show_minimize_button
        );
      },
      submission_text_ref() {
        return `submission-text-${this.submission.id}`;
      },
      response_adjusted_with_links() {
        if (this.$refs[this.submission_text_ref]) {
          this.submission_content_height = this.$refs[
            this.submission_text_ref
          ].clientHeight;
        }
        let prompt = this.submission.prompt_response;
        let listItemsString = '';
        const links = this.submission.links || [];
        if (links.length > 0) {
          links.forEach((link) => {
            const linkTag = `<li> <a href="${link.link}"target="_blank"> ${link.title} </a></li>`;
            listItemsString = listItemsString.concat(linkTag);
          });
          prompt = prompt.concat(`<hr /> Links: <ol> ${listItemsString} </ol>`);
        }
        return prompt;
      },
    },
    methods: {
      toggleMinimizeResponse() {
        this.minimize_response_text = !this.minimize_response_text;
        if (this.minimize_response_text) {
          this.$nextTick(() => {
            this.$emit('minimized');
          });
        } else {
          this.$store.dispatch('markSubmissionAsRead', this.submission.id);
        }
      },
      establishMinimizeButton() {
        this.submission_content_height = this.$refs[
          this.submission_text_ref
        ].clientHeight;
        // show button if height is bigger than 200 or if there is an image tag in submission
        // we assume image is bigger than 200px and requires button
        const response = this.submission.prompt_response;
        const imageTagExists = response ? response.includes('<img') : null;
        if (this.submission_content_height > 230 || imageTagExists) {
          this.show_minimize_button = !this.show_minimize_button;
        }
      },
    },
    mounted() {
      this.establishMinimizeButton();

      if (this.$route.params.sentence) {
        this.viewInContextSentence = this.$route.params.sentence;
      }

      document.addEventListener('mousedown', () => {
        if (this.viewInContextSentence) {
          setTimeout(() => {
            this.viewInContextSentence = null;
          }, 125);
        }
      });
    },
    updated() {
      let c = document.getElementById('scrollHere');
      if (c) {
        c.scrollIntoView({ behavior: 'smooth' });
      }
    },
  };
</script>
<style scoped lang="stylus">
  @import '~app/global-stylus.styl'
  .student-submission-text
    position: relative
    padding-top: 10px
    padding-bottom: 10px
    word-wrap: break-word
    .fadeout
      position: relative
      max-height: 200px // change the height
      overflow: hidden
      &.fadeout-shortened
        max-height: 80px // change the height
    .fadeout:after, .fadeout-shortened:after
      content: ''
      position: absolute
      top: 0
      bottom: 0
      left: 0
      right: 0
      background-image: linear-gradient( rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 1) 100% )
</style>



// WEBPACK FOOTER //
// submissionResponseText.vue?04eef867